
define('modules/application/wizard/classes/genericIncrementalElement',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {

  var genericIncrementalElement   = _.extend({}, genericElement, {

    Views       : {

      titleBar  : genericElement.Views.titleBar.extend({

        template: "application/wizard/sections/genericIncrementalElement/titleBar",

        tagName : "h3",

        initialize                     : function() {

          this.model.unbind("updateViews", this.setLabel);
          this.model.bind("updateViews", this.setLabel, this);

          this.model.set("titleBarView",this);
          this.model.bind('packages:fetching', this.setLoadingLabel, this);
          this.model.bind('packages:fetched',  this.setLabel, this);
        },

        setLabel                      : function() {
          if ((this.model.get("value")!==null)&&(this.model.get("value")>0))
          {
            this.$el.find(".caption").html(this.model.get("value"));
            this.$el.find(".caption").fadeIn(200);
          }
          else
            this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        enable                        : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeIn(200);
        },

        disable                       : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel                   : function() {
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        onClose: function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      }),

      content   : genericElement.Views.content.extend({
        template                      : "application/wizard/sections/genericIncrementalElement/content",
        className                     : "genericIncrementalElement",
        events                        : {
          "click .mainValue .ui-spinner-down"  : "decrementValue",
          "click .mainValue .ui-spinner-up"    : "incrementValue"
        },

        serialize                     : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        initialize                     : function() {

          this.model.unbind("updateViews", this.updateSpinners);
          this.model.bind("updateViews", this.updateSpinners, this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.set("contentView",this);
          if(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
            this.model.enableSection();
        },
        
        toggleInfos: function(e, currentScope) {
          return genericElement.Views.content.prototype.toggleInfos(e, currentScope);
        },

        decrementValue                : function() {
          if (this.model.get("enabled"))
            this.model.decrementValue();
        },

        incrementValue                : function() {
          if (this.model.get("enabled"))
            this.model.incrementValue();
        },

        disableSection                 : function() {
          if (!this.model.get("enabled"))
            this.$el.find(".mainValue").addClass("disabled");
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
            this.$el.find(".mainValue").removeClass("disabled");
        },

        isOpen                         : function()          {
          return this.$el.css("display")=="block";
        },

        updateSpinners                 : function() {
          this.$el.find(".mainValue .spinner").html(this.model.get("value"));
        },

        //Retrieve and set the accessory line's details
        afterRender                    : function()         {

          this.$el.find("h4.mainTitle").html($.i18n._(this.model.get("wizardChoiceLabel")));
          //

          if (this.model.get("packageClassDescription"))
          {
            if ($.i18n._(this.model.get("packageClassDescription")).length>360)
            {
              this.$el.find(".description.mainElement").text($.i18n._(this.model.get("packageClassDescription")).substring(0, 360));
              this.$el.find(".description.mainElement").append("<br /><br /><span class='tooltip'>"+$.i18n._("IDS_W1_9032")+" ›</span>");
            }
            else
              this.$el.find(".description.mainElement").text($.i18n._(this.model.get("packageClassDescription")));
          }

        },

        onClose                        : function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      })

    },

    Model       : genericElement.Model.extend({

      defaults                        : {
        enabled         : false,
        value           : 0,
        minValue        : 0,
        maxValue        : 99
      },

      initialize                      : function() {
        var that = this;

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', function(accessoryLineId)  {
          that.enableSection();
        });

        //Bind on accessory line removal
        window.BticinoS4B.eventAggregator.bind('accessoryLine:removed', function()      {
          that.disableSection();
        });

        window.BticinoS4B.eventAggregator.bind("load:Project",    this.loadProject, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",this.deliverModel, this);
      },

      decrementValue                  : function() {
        if (this.get("enabled"))
        {
          if ((this.get("value")-1)>=this.get("minValue"))
          {
            this.set("value", (this.get("value")-1));
            this.trigger("updateViews");
          }
          return this.get("value");
        }
        else
          return null;
      },

      incrementValue                  : function() {
        if (this.get("enabled"))
        {
          if ((this.get("value")+1)<=this.get("maxValue"))
          {
            this.set("value", (this.get("value")+1));
            this.trigger("updateViews");
          }
          return this.get("value");
        }
        else
          return null;
      },

      disableSection                  : function() {
        var that = this;

        this.set("enabled",false);
        this.get("contentView").disableSection();
        this.get("titleBarView").removeLabel();
        if(this.get("contentView").isOpen())
          this.get("titleBarView").disable();
      },

      enableSection                   : function() {
        var that = this;

        this.set("enabled",true);
        this.get("contentView").enableSection();
      }
    })

  });

  // Required, return the module for AMD compliance
  return genericIncrementalElement;

});